var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_46_1",
    "data-name": "Component 46 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 58,
    viewBox: "0 0 87 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1473",
    "data-name": "Rectangle 1473",
    width: 87,
    height: 58,
    rx: 11,
    fill: "#e6443b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset_8",
    "data-name": "Asset 8",
    transform: "translate(6.719 14.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M174.471,36.3a1.134,1.134,0,0,0-1.134-1.131,1.087,1.087,0,0,0-.928.478,3.752,3.752,0,0,0-1.886-.478h-.455a3.964,3.964,0,0,0-3.958,3.953v6.4a3.95,3.95,0,0,0,3.948,3.953h.465a3.854,3.854,0,0,0,1.688-.374v1.915a1.7,1.7,0,0,1-1.688,1.688h-.455a1.7,1.7,0,0,1-1.688-1.688,1.134,1.134,0,0,0-2.265,0,3.948,3.948,0,0,0,3.94,3.964h.468a3.948,3.948,0,0,0,3.953-3.945V36.3Z",
    transform: "translate(-122.71 -25.978)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M176.467,53.609a1.617,1.617,0,0,1-1.189-.489,1.649,1.649,0,0,1-.5-1.2v-6.4a1.7,1.7,0,0,1,1.688-1.688h.46a1.588,1.588,0,0,1,1.178.489,1.688,1.688,0,0,1,.509,1.2v6.4a1.693,1.693,0,0,1-.509,1.2,1.588,1.588,0,0,1-1.178.486Z",
    transform: "translate(-129.114 -32.376)",
    fill: "#e6443b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_12",
    "data-name": "Subtraction 12",
    d: "M-2728.345,1317.487h0l-.442,0h-.014a3.893,3.893,0,0,1-2.765-1.143,3.944,3.944,0,0,1-1.153-2.776v-6.352a3.951,3.951,0,0,1,3.932-3.919h.442a3.923,3.923,0,0,1,3.92,3.919v6.355A3.923,3.923,0,0,1-2728.345,1317.487Zm-.461-11.946a1.65,1.65,0,0,0-1.172.494,1.62,1.62,0,0,0-.493,1.178v6.373a1.674,1.674,0,0,0,1.668,1.651h.495a1.606,1.606,0,0,0,1.142-.481,1.64,1.64,0,0,0,.494-1.191v-6.352a1.693,1.693,0,0,0-1.675-1.672h-.459Z",
    transform: "translate(2785.726 -1294.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_13",
    "data-name": "Subtraction 13",
    d: "M-2728.36,1317.487h0l-.439,0a3.923,3.923,0,0,1-3.92-3.919v-6.352a3.917,3.917,0,0,1,1.154-2.765,3.915,3.915,0,0,1,2.766-1.154h.439a3.923,3.923,0,0,1,3.918,3.919v6.355A3.923,3.923,0,0,1-2728.36,1317.487Zm-.449-11.948a1.662,1.662,0,0,0-1.182.5,1.62,1.62,0,0,0-.494,1.178v6.373a1.657,1.657,0,0,0,.5,1.174,1.651,1.651,0,0,0,1.165.476h.5a1.6,1.6,0,0,0,1.142-.482,1.639,1.639,0,0,0,.493-1.192v-6.349a1.694,1.694,0,0,0-1.674-1.675h-.449Z",
    transform: "translate(2794.878 -1294.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M1.134,25.034A1.129,1.129,0,0,0,0,26.168V38.252a1.134,1.134,0,0,0,2.265,0h0V26.176a1.131,1.131,0,0,0-1.131-1.142Zm0-3.525A1.123,1.123,0,0,0,0,22.631v.112a1.134,1.134,0,0,0,2.265,0h0v-.089A1.129,1.129,0,0,0,1.142,21.52ZM13.3,25.079a3.94,3.94,0,0,0-2.822,1.189,3.932,3.932,0,0,0-2.832-1.189H7.2a3.739,3.739,0,0,0-1.892.478,1.087,1.087,0,0,0-.93-.486A1.126,1.126,0,0,0,3.25,26.195V38.252a1.134,1.134,0,0,0,2.265,0h0v-9.22a1.609,1.609,0,0,1,.494-1.189,1.651,1.651,0,0,1,1.2-.5h.442a1.649,1.649,0,0,1,1.2.5,1.617,1.617,0,0,1,.5,1.189v9.22a1.134,1.134,0,1,0,2.265,0h0v-9.22a1.612,1.612,0,0,1,.489-1.189,1.651,1.651,0,0,1,1.2-.5h.434a1.651,1.651,0,0,1,1.2.5,1.617,1.617,0,0,1,.5,1.189v9.22a1.134,1.134,0,1,0,2.265,0h0v-9.22a3.971,3.971,0,0,0-3.966-3.953Zm15.363,0a3.94,3.94,0,0,0-2.822,1.189,3.932,3.932,0,0,0-2.832-1.189h-.444a3.752,3.752,0,0,0-1.892.478,1.082,1.082,0,0,0-.928-.486,1.129,1.129,0,0,0-1.134,1.123V38.252a1.134,1.134,0,0,0,2.265.037V29.032a1.612,1.612,0,0,1,.489-1.189,1.651,1.651,0,0,1,1.2-.5h.442a1.651,1.651,0,0,1,1.2.5,1.617,1.617,0,0,1,.5,1.189v9.22a1.134,1.134,0,1,0,2.265,0v-9.22a1.609,1.609,0,0,1,.486-1.189,1.651,1.651,0,0,1,1.2-.5H29.1a1.649,1.649,0,0,1,1.2.5,1.617,1.617,0,0,1,.5,1.189v9.22a1.134,1.134,0,1,0,2.265,0v-9.22a3.971,3.971,0,0,0-3.964-3.953ZM42.946,38.072a1.7,1.7,0,0,1-.784-1.427V26.166a1.129,1.129,0,0,0-1.123-1.131h0a1.092,1.092,0,0,0-.961.523,3.747,3.747,0,0,0-1.871-.476h-.442a3.964,3.964,0,0,0-3.961,3.95v6.4a3.95,3.95,0,0,0,3.948,3.953H38.2a3.843,3.843,0,0,0,2.255-.7,4.277,4.277,0,0,0,1.259,1.306,1.126,1.126,0,0,0,1.568-.334h0a1.113,1.113,0,0,0-.306-1.557l-.029-.021Zm-5.189-.951a1.664,1.664,0,0,1-1.688-1.636V29.032a1.623,1.623,0,0,1,.489-1.191,1.656,1.656,0,0,1,1.2-.5H38.2a1.7,1.7,0,0,1,1.7,1.688v6.4a1.685,1.685,0,0,1-1.677,1.688h-.468Z",
    transform: "translate(0 -15.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(53.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M220.265,6.336l-2.613-2.284V1.413a1,1,0,0,0-1.978,0v.912l-1.947-1.7a2.874,2.874,0,0,0-3.6,0L203.6,6.333a.784.784,0,0,0,0,1.223,1.1,1.1,0,0,0,1.4,0l6.532-5.711a.643.643,0,0,1,.8,0l6.532,5.711a1.092,1.092,0,0,0,1.4,0,.784.784,0,0,0,0-1.223Z",
    transform: "translate(-203.307 0.007)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.276e6690d1dede74da21f610916f1907.svg";
export { ForwardRef as ReactComponent };